<script>

    import {onMount} from "svelte";
    import gsap from 'gsap';
    import {labels, mainTimeline} from "../../timelines/main-timeline";

    const inTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    const {threeLeadersStart, threeLeadersEnd} = labels;

    const images = [`images/person1@2x.png`, `images/person3@2x.png`, `images/person5@2x.png`];

    const widths = [155, 211, 207].map(n => n * 0.6);
    const x = [786, 964, 1168].map(x => x - 80);
    const y = [581, 500, 576].map(y => y - 40);

    const getSelector = (i) => '.threeLeaders' + i;

    onMount(() => {
        images.forEach((_, i) => {
            inTimeline.to(getSelector(i), {
                opacity: 1,
                duration: 0.065,
            }).to(getSelector(i), {
                opacity: 0,
                duration: 0.065,
            }).to(getSelector(i), {
                opacity: 1,
                duration: 0.065,
            });

            const randomOffset = Math.random() * 0.8;

            outTimeline.to(getSelector(i), {
                opacity: 0,
                duration: 0.065,
            }, randomOffset).to(getSelector(i), {
                opacity: 1,
                duration: 0.065,
            }, '>').to(getSelector(i), {
                opacity: 0,
                duration: 0.065,
            }, '>');
        });

        mainTimeline.add(inTimeline, threeLeadersStart);
        mainTimeline.add(outTimeline, threeLeadersEnd);
    });

</script>

<g>
    {#each images as src, i}
        <image href={src} class={' threeLeaders threeLeaders' + i} x={x[i] + 'px'} y={y[i]  + 'px'} width={widths[i]}/>
    {/each}
</g>

<style>
    .threeLeaders {
        opacity: 0;
    }
</style>